import * as React from 'react';

import {Button} from 'shells/button/button';
import {Illustration} from 'shells/illustrations/illustration';
import {TwoPaneModal} from 'shells/modal/two-pane-modal';

import type {CalendarSync} from 'nutshell-graphql-types';

import {Connected} from './pages';

import styles from './calendar-edit-modal.module.css';

type Props = {
    calendarSync: CalendarSync | null | undefined;
    isLoading: boolean;
    refetchSyncStatus: () => Promise<any>;
    setIsEditModalOpen: (isModalOpen: boolean) => void;
};

export function CalendarEditModal(props: Props) {
    return (
        <TwoPaneModal
            closeButton={false}
            // @ts-expect-error
            isOpen={true}
            maxHeight={600}
            onClose={() => {
                props.setIsEditModalOpen(false);
            }}
            leftSection={
                <div className={styles.left}>
                    <Illustration src='calendar-lady' width={210} />
                </div>
            }
            rightSection={
                <div className='flex'>
                    <Connected
                        calendarSync={props.calendarSync}
                        isLoading={props.isLoading}
                        refetchSyncStatus={props.refetchSyncStatus}
                        setIsEditModalOpen={props.setIsEditModalOpen}
                        oneStepDisconnect={true}
                    />
                    <div className={styles['done-button']}>
                        <Button variant='primary' onClick={() => props.setIsEditModalOpen(false)}>
                            Done
                        </Button>
                    </div>
                </div>
            }
        />
    );
}
